import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { SectionHeading, Reveal } from "./Reveal";
import { Rangoli, Diya, Potli, Marigold, Lantern, Rakhi, Hanging, Bunting } from "./motifs";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE } from "@/lib/site";

const TILES = [
    { Motif: Rangoli, accent: "#EA580C" },
    { Motif: Diya, accent: "#E2BA03" },
    { Motif: Potli, accent: "#047857" },
    { Motif: Marigold, accent: "#EA580C" },
    { Motif: Lantern, accent: "#BE123C" },
    { Motif: Rakhi, accent: "#E2BA03" },
    { Motif: Hanging, accent: "#047857" },
    { Motif: Bunting, accent: "#BE123C" },
];

const Gallery = () => (
    <section id="gallery" data-testid="gallery-section" className="relative py-28 sm:py-40 bg-[#EAE6DA]/60">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <div className="flex flex-wrap items-end justify-between gap-6 mb-16">
                <SectionHeading
                    eyebrow="From Our Feed"
                    title={<>The <em className="italic text-[#E2BA03] [text-shadow:0_1px_0_#472500]">Gallery</em></>}
                    testId="gallery-heading"
                />
                <Reveal delay={0.15}>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="gallery-follow-button"
                        className="group inline-flex items-center gap-2.5 rounded-full border border-[#472500]/40 text-[#472500] font-medium px-7 py-3.5 text-sm transition-all duration-300 hover:bg-[#472500] hover:text-[#F0EEE8]"
                    >
                        <Instagram size={17} />
                        Follow {INSTAGRAM_HANDLE}
                    </a>
                </Reveal>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
                {TILES.map((t, i) => (
                    <motion.a
                        key={i}
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`gallery-tile-${i + 1}`}
                        initial={{ opacity: 0, scale: 0.92 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
                        viewport={{ once: true, margin: "-40px" }}
                        className="group relative aspect-square rounded-2xl border border-[#472500]/15 bg-[#F7F4EC] overflow-hidden grid place-items-center"
                        aria-label={`Instagram placeholder ${i + 1} — opens @festivetheory`}
                    >
                        <t.Motif
                            className="w-2/5 opacity-40 transition-all duration-500 group-hover:opacity-70 group-hover:scale-110"
                            style={{ color: t.accent }}
                        />
                        <span className="absolute inset-0 bg-[#472500]/0 group-hover:bg-[#472500]/60 transition-colors duration-400 grid place-items-center">
                            <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-400 text-[#F0EEE8] text-xs uppercase tracking-[0.25em] flex items-center gap-2">
                                <Instagram size={14} /> {INSTAGRAM_HANDLE}
                            </span>
                        </span>
                    </motion.a>
                ))}
            </div>
            <Reveal delay={0.1} className="mt-8">
                <p className="text-sm text-[#472500]/55">
                    Placeholder tiles — ready for the owner to populate with Festive Theory's Instagram photography.
                </p>
            </Reveal>
        </div>
    </section>
);

export default Gallery;
